export const LOWER_THAN = 'LOWER_THAN';
export const GREATER_THAN = 'GREATER_THAN';
export const EQUAL = 'EQUAL';
export const LABEL_CONTAINS = 'LABEL_CONTAINS';
